import { ArrowRight } from 'lucide-react';
import { useRouter } from 'next/router';

import { t } from '@ping/helpers';
import { useVotingMembers } from '@ping/pages/user/business/governance-review.api';
import { governanceErrorMessage } from '@ping/pages/user/business/trading-governance.api';
import { ButtonA11Y, Loading, Text } from '@ping/uikit';

import style from './style.module.scss';

import type { LinkProps } from 'next/link';

export const BusinessWithdrawalConfirmation = ({ requestId }: { requestId: string }) => {
  const router = useRouter();
  const members = useVotingMembers(true);
  const voters = members.data || [];

  return (
    <div className={style['confirmation']}>
      <Text heading='4'>{t('Waiting for CorePass')}</Text>
      <Text body='regular' className={style['lead']}>
        {t(
          'This withdrawal is a governance request. It stays pending until CorePass reports it signed, and Ping then continues it. Ask a member below to approve it in CorePass.'
        )}
      </Text>
      <Text body='regular' className={style['requestId']}>
        {requestId}
      </Text>
      <Text caption='regular' className={style['note']}>
        {t(
          'These members can vote on the signature request. This is not a list of who has already signed, and it is not legal signatory authority.'
        )}
      </Text>
      {members.isLoading && <Loading />}
      {members.isError && (
        <Text body='regular' className={style['error']}>
          {t(governanceErrorMessage(members.error))}
        </Text>
      )}
      {!members.isLoading && !members.isError && !voters.length && (
        <Text body='regular' className={style['note']}>
          {t('No members with voting rights were returned.')}
        </Text>
      )}
      {voters.length > 0 && (
        <ul className={style['members']}>
          {voters.map(member => (
            <li key={`${member.memberName}-${member.cnsDomain}`} className={style['member']}>
              <Text body='regular'>{member.memberName || t('Unnamed member')}</Text>
              {member.cnsDomain && (
                <Text caption='regular' className={style['domain']}>
                  {member.cnsDomain}
                </Text>
              )}
            </li>
          ))}
        </ul>
      )}
      <div className={style['requestsAction']}>
        <Text caption='regular' className={style['note']}>
          {t('Follow this request in the Withdrawals section.')}
        </Text>
        <ButtonA11Y primary onPress={() => router.push('/user/business/withdrawals/requests' as LinkProps['href'])}>
          {t('Open withdrawal requests')}
          <ArrowRight size={16} aria-hidden />
        </ButtonA11Y>
      </div>
    </div>
  );
};
